export default __webpack_public_path__ + "static/media/clubracers-1.ffffc3b7.jpg";